<template>
  <v-btn
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component', schema.attributesButton.class]"
    :name="schema.model"
    :id="setId(schema.model)"
    v-bind="schema.attributesButton"
    :disabled="schema.readonly"
    :loading="loading"
    @click="execute"
  >
    <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconLeft" v-bind="schema.attributesIcon">
      {{ schema.attributesIcon.icon }}
    </v-icon>
    {{ schema.attributesButton.label }}
    <v-icon v-if="schema.attributesIcon && schema.attributesIcon.showIconRight" v-bind="schema.attributesIcon">
      {{ schema.attributesIcon.icon }}
    </v-icon>
  </v-btn>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin],

  data: () => ({
    loading: false
  }),

  events: {
    [HANDLERS.INIT_LOADING]: 'initLoading',
    [HANDLERS.FINISH_LOADING]: 'finishLoading'
  },

  methods: {
    execute() {
      this.$emit(HANDLERS.EXECUTE_ACTION, { action: this.schema, origin: this.formOptions.page });
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    },

    initLoading() {
      this.loading = true;
    },

    finishLoading() {
      this.loading = false;
    }
  }
};
</script>
